// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6bc5695","389":"536f9e3d","455":"47742f4c","977":"341bdaae"}[chunkId] + ".chunk.js";
};